import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BlogPostPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    axios.get(`${API}/blog/${id}`).then(r => setPost(r.data)).catch(() => {});
  }, [id]);

  if (!post) return <div className="min-h-screen bg-[#050505] flex items-center justify-center text-[#B026FF]">Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-24 pb-24 px-6">
        <div className="container mx-auto max-w-3xl">
          <Link to="/blog" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#B026FF] mb-8" data-testid="back-to-blog"><ArrowLeft className="w-4 h-4" /> Blog'a Dön</Link>
          {post.image_url && <img src={post.image_url} alt={post.title} className="w-full h-64 object-cover rounded-lg mb-8" />}
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="blog-post-title">{post.title}</h1>
          <p className="text-[#71717A] text-sm mb-8">{new Date(post.created_at).toLocaleDateString('tr-TR')}</p>
          <div className="prose prose-invert max-w-none">
            {post.content?.split('\n').map((p, i) => <p key={i} className="text-[#A1A1AA] leading-relaxed mb-4">{p}</p>)}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
